import { render, staticRenderFns } from "./BigFileView.vue?vue&type=template&id=1e5ca8c8"
import script from "./BigFileView.ts?vue&type=script&lang=ts&external"
export * from "./BigFileView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports